import { Trans, useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import checklistStyles from '~/checklist/styles/Checklist.module.css'

interface Props {
  label?: string
  isCompleted: boolean
  disableOnComplete?: boolean
  onCheckboxClick: (event: React.MouseEvent<HTMLElement>) => void
}

export default function CheckBox({
  label,
  disableOnComplete = true,
  isCompleted,
  onCheckboxClick,
}: Props): React.ReactElement {
  const { t } = useTranslation('generics')

  const handleCheckBoxClick = (event: React.MouseEvent<HTMLElement>): void => {
    if (isCompleted && disableOnComplete) return
    onCheckboxClick(event)
  }
  return (
    <div className="flex items-center justify-center">
      <button
        aria-label={t('ariaLabelButtons.checkBox')}
        className={`relative bg-white rounded ${
          isCompleted && disableOnComplete ? 'cursor-not-allowed' : 'cursor-pointer'
        } ${checklistStyles['tap-effect-none']}`}
        id="curriculum-tutorial-promise-checkbox"
        onClick={handleCheckBoxClick}
      >
        <div className="w-4 h-4 border-2 border-purple rounded-[3px]" />
        <ResponsiveImage
          alt=""
          className={`absolute left-0.5 top-0 w-4 ${isCompleted ? 'block' : 'hidden'}`}
          height={30}
          srcKey="icons/checklist-checkmark.png"
          width={39}
        />
      </button>
      {label && (
        <label className="ml-2 text-base font-light" htmlFor="curriculum-tutorial-promise-checkbox">
          <Trans
            components={{
              orange: <span className="text-orange font-bold" />,
              italic: <span className="italic" />,
              green: (
                <span
                  className="font-bold"
                  style={{
                    background: 'var(--puzzle-color, linear-gradient(224deg, #CEDA5F 28.01%, #74EB95 88.73%))',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                />
              ),
            }}
            i18nKey={label}
          />
        </label>
      )}
    </div>
  )
}
